import React, { FC, CSSProperties } from 'react';
import s from './Button.module.css';

type ButtonState = 'enabled' | 'disabled' | 'loading';
type IconPosition = 'left' | 'right';

interface ButtonProps {
    text?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    state?: ButtonState;
    style?: CSSProperties;
    icon?: string | React.ReactNode;
    iconPosition?: IconPosition;
    type?: 'button' | 'submit';
}

const Button: FC<ButtonProps> = ({
    text,
    onClick,
    state = 'enabled',
    style,
    icon,
    iconPosition = 'left',
    type = 'button',
}) => {
    const buttonClass = `${s.button} ${s[state]}`;
    const iconClass = iconPosition === 'left' ? s.iconLeft : s.icon;

    return (
        <button
            type={type}
            onClick={onClick}
            className={buttonClass}
            style={{ ...style }}
            disabled={state === 'disabled' || state === 'loading'}
        >
            {icon &&
                iconPosition === 'left' &&
                (typeof icon === 'string' ? (
                    <img src={icon} alt="" className={iconClass} />
                ) : (
                    <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>
                ))}
            {text} {state === 'loading' && <div className={s.spinner}></div>}
            {icon &&
                iconPosition === 'right' &&
                (typeof icon === 'string' ? (
                    <img src={icon} alt="" className={iconClass} />
                ) : (
                    <span className={iconClass} style={{ display: 'flex' }}>
                        {icon}
                    </span>
                ))}
        </button>
    );
};

export default Button;
